module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QoYCBMQvJoFGAAAAGZJREFUSMdjYBgFQx0wkqohobb7P4y9oLmUkZA4OmAi1zJsfGIAE7mW0TRISbWMoiClls+IspDaluG1kBaW4YxDaliGKx4ZaekzbJYyDaqShlzfUq2koXm2GLVw1MKRaeEoGAUkAwCjtSaMmNf70wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/residencial_unifamiliar.png
// module id = WpFv
// module chunks = 0